'use strict';

var style = require('./style');

module.exports = style({
  prop: 'borderColor',
  key: 'colors'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/border-color.js
// module id = 649
// module chunks = 3